//check .apply
export function overridable(origFn) {
    //@ts-expect-error
    if (window.isResponsive !== true) {
        return origFn;
    }
    var targetFn = origFn;
    var resultFn = function () {
        //eslint-disable-next-line prefer-rest-params
        return targetFn.apply(this, arguments);
    };
    resultFn.getOrig = function () { return origFn; };
    resultFn.override = function (newFunc) {
        targetFn = newFunc;
    };
    return resultFn;
}
